/**
 * 包含展示端的页面路由
 * 首页
 * 分类页
 * 测评详情页
 * 套餐详情页
 * 我的测评页
 */

import index from '../pages/show/index.vue'
import showIndex from '../pages/show/showIndex.vue'
import { loadPageFail } from '../lib/units';

export default {
    name: 'show',
    path: '/index',
    component: index,
    children: [
        // search
        {
            name: 'search',
            path: '/search',
            meta: {
                title: '搜索页'
            },
            component: resolve => require(['../pages/show/search.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '搜索页',
                    err
                });
            }),
        },
        // index
        {
            name: 'showIndex',
            path: '/index',
            meta: {
                title: '首页',
            },
            component: showIndex
        },
        // redirect to index with channelId
        {
            path: '/index/:channelId',
            redirect: to => {
                // 方法接收 目标路由 作为参数
                return {
                    path: '/index',
                    query: {
                        channelId: to.params.channelId
                    }
                }
            }
        },
        // /sorts 分类页
        {
            name: 'sorts',
            path: '/sorts',
            meta: {
                title: '分类页',
            },
            component: resolve => require(['../pages/show/sorts.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '分类页',
                    err
                });
            }),
        },
        // testdetail 测评详情
        {
            name: 'testDetail',
            path: '/detail/:testId',
            meta: {
                title: '测评详情页',
                fullTitle: function() {
                    let rs = '测评详情页';
                    if (this.query.enterFrom == 'testDetail') {
                        rs += '-大家都在测'
                    }
                    return rs;
                }
            },
            component: resolve => require(['../pages/show/testDetail.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '测评详情页',
                    err
                });
            })
        },
        {
            name: 'testDetailIQ',
            path: '/detail-iq',
            meta: {
                title: '测评详情页',
                fullTitle: function() {
                    let rs = '测评详情页';
                    return rs;
                },
                hideFooter: true, // 隐藏首页底部栏
            },
            component: resolve => require(['../pages/show/test-detail-iq.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '测评详情页',
                    err
                });
            })
        },
        {
            name: 'testDetailYY',
            path: '/detail-yy/:testId',
            meta: {
                title: '抑郁测评二选一',
                fullTitle: function() {
                    let rs = '抑郁测评二选一';
                    return rs;
                },
                hideFooter: true, // 隐藏首页底部栏
            },
            component: resolve => require(['../pages/show/test-detail-yy.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '抑郁测评二选一',
                    err
                });
            })
        },
        {
            name: 'testDetailMBTI',
            path: '/detail-mbti/:testId',
            meta: {
                title: 'MBTI二选一',
                fullTitle: function() {
                    let rs = 'MBTI二选一';
                    return rs;
                },
                hideFooter: true, // 隐藏首页底部栏
            },
            component: resolve => require(['../pages/show/test-detail-mbti.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: 'MBTI二选一',
                    err
                });
            })
        },
        // 2021525支付成功页
        {
            name: 'paySuccess',
            path: '/paysuccess',
            meta: {
                title: '支付成功'
            },
            component: resolve => require(['../pages/show/activity/2021525/pay-success.vue'], resolve)
        },
        {
            name: 'toufangDetail',
            path: '/toufang_detail/:testId/:channelId',
            meta: {
                title: '百度投放详情页',
                fullTitle: function() {
                    let rs = '百度投放详情页';
                    if (this.query.enterFrom == 'toufangDetail') {
                        rs += '-大家都在测'
                    }
                    return rs;
                }
            },
            component: resolve => require(['../pages/show/testDetail.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '百度投放详情页',
                    err
                });
            })
        },
        // redirect to testdetail with channelId
        {
            path: '/detail/:testId/:channelId',
            redirect: to => {
                // 方法接收 目标路由 作为参数
                return {
                    path: '/detail/:testId',
                    query: {
                        channelId: to.params.channelId
                    }
                }
            }
        },
        // combodetail 套餐详情
        {
            name: 'comboDetail',
            path: '/combo/:comboId',
            meta: {
                title: '套餐详情页',
            },
            component: resolve => require(['../pages/show/combo/comboDetail.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '套餐详情页',
                    err
                });
            }),
        },
        {
            path: '/combo/:comboId/:channelId',
            redirect: to => {
                // 方法接收 目标路由 作为参数
                return {
                    path: '/combo/:comboId',
                    query: {
                        channelId: to.params.channelId,
                    }
                }
            }
        },
        // 我的测评
        {
            name: 'myTests',
            path: '/mine/:status',
            meta: {
                title: '我的测评',
                fullTitle: function() {
                    let rs = '我的测评';
                    if (this.params.status == 0) {
                        rs += '-未完成'
                    } else if (this.params.status == 1) {
                        rs += '-已完成'
                    } else {
                        rs = '收藏'
                    }
                    return rs;
                }
            },
            component: resolve => require(['../pages/show/myTests.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '我的测评页',
                    err
                });
            }),
        },
        {
            path: '/mine/',
            redirect: '/mine/0'
        },
        {
            path: '/mine/:status/:channelId',
            redirect: to => {
                // 方法接收 目标路由 作为参数
                return {
                    query: {
                        channelId: to.params.channelId
                    }
                }
            }
        },
        // 免登陆个人中心
        {
            name: 'noLoginCenter',
            path: '/noLoginCenter',
            meta: {
                title: '个人中心',
                fullTitle: function() {
                    let rs = '个人中心';
                    return rs;
                }
            },
            component: resolve => require(['../pages/show/noLoginMyCenter.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '个人中心页',
                    err
                });
            }),
        },
        // index
        {
            name: 'showIndex-skeleton',
            path: '/indexSkeleton',
            meta: {
                title: '首页骨架图',
            },
            component: resolve => require(['../pages/show/skeleton/showIndex-skeleton.vue'], resolve, (err) => {})
        },
        // index
        {
            name: 'sort-skeleton',
            path: '/sortSkeleton',
            meta: {
                title: '分类页骨架图',
            },
            component: resolve => require(['../pages/show/skeleton/sorts-skeleton.vue'], resolve, (err) => {})
        },
        // index
        {
            name: 'mine-skeleton',
            path: '/mineSkeleton',
            meta: {
                title: '我的测评骨架图',
            },
            component: resolve => require(['../pages/show/skeleton/mine-skeleton.vue'], resolve, (err) => {})
        },
        {
            name: 'myCoupon',
            path: '/myCoupon',
            meta: {
                title: '我的优惠券',
                fullTitle: function() {
                    return '我的优惠券';
                }
            },
            component: resolve => require(['../pages/show/myCoupon.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '我的优惠券',
                    err
                });
            }),
        },
        {
            name: 'myReports',
            path: '/myReports',
            meta: {
                title: '我的报告',
                fullTitle: function() {
                    return '我的报告';
                }
            },
            component: resolve => require(['../pages/show/myReports.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '我的报告',
                    err
                });
            }),
        },
        {
            name: 'myEvaluate',
            path: '/myEvaluate',
            meta: {
                title: '我的评价',
                fullTitle: function() {
                    return '我的评价';
                }
            },
            component: resolve => require(['../pages/show/myEvaluate.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '我的评价',
                    err
                });
            }),
        },
        {
            name: 'myCard',
            path: '/myCard',
            meta: {
                title: '卡包',
                fullTitle: function() {
                    return '卡包';
                }
            },
            component: resolve => require(['../pages/show/myCard/card-list.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '卡包',
                    err
                });
            }),
        },
        {
            name: 'cardDetail',
            path: '/card-detail',
            meta: {
                title: '卡详情',
                fullTitle: function() {
                    return '卡详情';
                }
            },
            component: resolve => require(['../pages/show/myCard/card-detail.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '卡详情',
                    err
                });
            }),
        },
        {
            name: 'cardRecord',
            path: '/card-record',
            meta: {
                title: '使用记录',
                fullTitle: function() {
                    return '使用记录';
                }
            },
            component: resolve => require(['../pages/show/myCard/card-record.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '使用记录',
                    err
                });
            }),
        },
        {
            name: 'cardDesc',
            path: '/card-desc',
            meta: {
                title: '领取成功',
                fullTitle: function() {
                    return '领取成功';
                }
            },
            component: resolve => require(['../pages/show/myCard/card-desc.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '领取成功',
                    err
                });
            }),
        },
        {
            name: 'myOrder',
            path: '/myOrder',
            meta: {
                title: '我的订单',
                fullTitle: function() {
                    return '我的订单';
                }
            },
            component: resolve => require(['../pages/show/myOrder.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '我的订单',
                    err
                });
            }),
        },
        {
            name: 'myLike',
            path: '/myLike',
            meta: {
                title: '个人中心-喜欢列表',
                fullTitle: function() {
                    return '个人中心-喜欢列表';
                }
            },
            component: resolve => require(['../pages/show/myLike.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '个人中心-喜欢列表',
                    err
                });
            }),
        },
        {
            name: 'myFavorite',
            path: '/myFavorite',
            meta: {
                title: '个人中心-收藏列表',
                fullTitle: function() {
                    return '个人中心-收藏列表';
                }
            },
            component: resolve => require(['../pages/show/myFavorite.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '个人中心-收藏列表',
                    err
                });
            }),
        },
        // 趣味测试
        {
            name: 'ceshi',
            path: '/ceshi/:id',
            meta: {
                title: '趣味测试详情'
            },
            component: resolve => require(['../pages/ceshi/funDetail'], resolve, (err) => {
                loadPageFail({
                    pagename: '趣味测试详情',
                    err
                })
            })
        },
        {
          name: 'fun-result',
          path: '/ceshi/:id/result/:resultId',
          meta: {
              title: '测试结果页'
          },
          component: resolve => require(['../pages/ceshi/funResult'], resolve, (err)=>{
              loadPageFail({
                  pagename: '测试结果页',
                  err
              });
          })
        },
        {
            name: 'searchOrder',
            path: '/searchOrder',
            meta: {
                title: '查询订单',
                fullTitle: function() {
                    return '查询订单';
                }
            },
            component: resolve => require(['../pages/show/searchOrder.vue'], resolve, (err) => {
                loadPageFail({
                    pagename: '查询订单',
                    err
                });
            }),
        },
        {
            name: 'vip4Detail',
            path: '/vip4Detail',
            meta: {
                title: '会员详情页'
            },
            component: resolve => require(['../pages/show/activity/2023vip/detail'], resolve, (err) => {
                loadPageFail({
                    pagename: '会员详情页',
                    err
                });
            }),
        },
        {
            name: 'vip4-user-center',
            path: '/vip4UserCenter',
            meta: {
                title: '会员中心'
            },
            component: resolve => require(['../pages/show/activity/2023vip/userCenter'], resolve, (err)=>{
                loadPageFail({
                    pagename: '会员中心',
                    err
                });
            })
        },

    ]
};



// WEBPACK FOOTER //
// ./src/router/show.js